import React from 'react';
import { COLORS } from 'config/theme';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  color: ${COLORS.primaryColor};
  font-size: 21.1px;
  letter-spacing: 0.3px;

  button {
    margin-left: -12px;
  }
`;

const Title = ({
  openSidebar,
  toggleSidebar,
  selectedTag,
}) => {
  return (
    <StyledTitle>
      <IconButton onClick={toggleSidebar}>
        <MenuIcon />
      </IconButton>

      {selectedTag.name}
    </StyledTitle>
  );
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Title/Title.jsx